<div class="d-flex justify-content-center">
  <div class="grey-card pb-55 w-100">
    @if (title) {
      <app-page-heading [title]="title" [showLogo]="showLogo" [setMaxWidth350]="setHeadingMaxWidth350"/>
    }
    <div class="grey-card__content-wrapper" [ngStyle]="{'padding-top': removeContentPaddingTop ? '0' : '100px'}">
      <ng-content></ng-content>
    </div>
  </div>
</div>
